/**
 * Брендовая кнопка «‹ Назад» (.ta-back-btn) — единый паттерн возврата.
 *
 * Патент проекта: ЛЮБОЙ экран = «Назад» сверху (feedback_every_form_is_a_
 * separate_screen). Используется на целевых экранах быстрых действий дашборда
 * (#82) и формах. По умолчанию ведёт на дашборд («/»); для вложенных экранов
 * можно передать `to` или `onClick`.
 */
import { useNavigate } from 'react-router-dom';

export interface BackButtonProps {
  /** Куда вернуться. По умолчанию — дашборд роли «/». */
  to?: string;
  /** Своя обработка (приоритетнее `to`) — напр. закрыть подформу. */
  onClick?: () => void;
  /** Текст кнопки. По умолчанию «Назад». */
  label?: string;
  testId?: string;
}

export function BackButton({
  to = '/',
  onClick,
  label = 'Назад',
  testId,
}: BackButtonProps): JSX.Element {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="ta-back-btn"
      onClick={onClick ?? (() => navigate(to))}
      {...(testId ? { 'data-testid': testId } : {})}
    >
      <span className="ta-back-btn__chev" aria-hidden="true">
        ‹
      </span>{' '}
      {label}
    </button>
  );
}
